module.exports = __webpack_public_path__ + "img/pro-xtIcon6.028358bb.png";